import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Error } from '../models';
import { IssueReportingService } from '../issue-reporting.service';
import * as i0 from "@angular/core";
import * as i1 from "../issue-reporting.service";
import * as i2 from "@angular/common";
import * as i3 from "@angular/material/expansion";
import * as i4 from "@angular/material/icon";
import * as i5 from "@angular/material/legacy-button";
function ErrorItemComponent_p_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "json");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("Error data: ", i0.ɵɵpipeBind1(2, 1, ctx_r0.error.error), "");
} }
function ErrorItemComponent_p_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("Source: ", ctx_r0.error.source, "");
} }
export class ErrorItemComponent {
    constructor(issueReporting) {
        this.issueReporting = issueReporting;
        // eslint-disable-next-line @angular-eslint/no-output-on-prefix
        this.onDismiss = new EventEmitter();
        this.errorLink = '';
    }
    ngOnInit() {
        this.errorLink = this.issueReporting.getReportIssueWithErrorMailLink(this.error);
    }
    static { this.ɵfac = function ErrorItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ErrorItemComponent)(i0.ɵɵdirectiveInject(i1.IssueReportingService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ErrorItemComponent, selectors: [["app-error-item"]], inputs: { error: "error" }, outputs: { onDismiss: "onDismiss" }, standalone: false, decls: 28, vars: 4, consts: [["color", "error"], ["mat-icon-button", "", "color", "warn", 1, "dismiss-error", 3, "click"], [4, "ngIf"], ["id", "errorLink", 3, "href"]], template: function ErrorItemComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-expansion-panel");
            i0.ɵɵtext(1, "\n  ");
            i0.ɵɵelementStart(2, "mat-expansion-panel-header");
            i0.ɵɵtext(3, "\n    ");
            i0.ɵɵelementStart(4, "mat-panel-title");
            i0.ɵɵtext(5, "\n      ");
            i0.ɵɵelementStart(6, "mat-icon", 0);
            i0.ɵɵtext(7, "error");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd();
            i0.ɵɵtext(9, "\n    ");
            i0.ɵɵelementStart(10, "mat-panel-description");
            i0.ɵɵtext(11, "\n      ");
            i0.ɵɵelementStart(12, "button", 1);
            i0.ɵɵlistener("click", function ErrorItemComponent_Template_button_click_12_listener() { return ctx.onDismiss.emit(ctx.error); });
            i0.ɵɵtext(13, "\n        ");
            i0.ɵɵelementStart(14, "mat-icon");
            i0.ɵɵtext(15, "clear");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(16, "\n      ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(17, "\n    ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(18, "\n  ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(19, "\n\n  ");
            i0.ɵɵtemplate(20, ErrorItemComponent_p_20_Template, 3, 3, "p", 2);
            i0.ɵɵtext(21, "\n  ");
            i0.ɵɵtemplate(22, ErrorItemComponent_p_22_Template, 2, 1, "p", 2);
            i0.ɵɵtext(23, "\n  ");
            i0.ɵɵelementStart(24, "a", 3);
            i0.ɵɵtext(25, "Report This Issue");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(26, "\n\n");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(27, "\n");
        } if (rf & 2) {
            i0.ɵɵadvance(8);
            i0.ɵɵtextInterpolate1("", ctx.error.message, "\n    ");
            i0.ɵɵadvance(12);
            i0.ɵɵproperty("ngIf", ctx.error.error);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.error.source);
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("href", ctx.errorLink, i0.ɵɵsanitizeUrl);
        } }, dependencies: [i2.NgIf, i3.MatExpansionPanel, i3.MatExpansionPanelHeader, i3.MatExpansionPanelTitle, i3.MatExpansionPanelDescription, i4.MatIcon, i5.MatLegacyButton, i2.JsonPipe], styles: ["\n\n[_nghost-%COMP%] {\n  flex: 1;\n}\nmat-expansion-panel-header[_ngcontent-%COMP%]     .mat-content {\n  line-height: 24px;\n}\nmat-expansion-panel-header[_ngcontent-%COMP%]     .mat-content mat-panel-description   {\n  flex: 0;\n}\nmat-expansion-panel-header[_ngcontent-%COMP%]     .mat-content mat-panel-description   button.dismiss-error {\n  height: 24px;\n  width: 24px;\n}\nmat-expansion-panel-header[_ngcontent-%COMP%]     .mat-content mat-panel-description   mat-icon   {\n  vertical-align: text-bottom;\n}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ErrorItemComponent, { className: "ErrorItemComponent", filePath: "libs/web/angular/shared/util/error-handling/src/lib/error-item/error-item.component.ts", lineNumber: 11 }); })();
//# sourceMappingURL=error-item.component.js.map